import React from "react"
import useFetchAiAnalyticsWidgetData from "../../../hooks/useFetchAiAnalyticsWidgetData"
import MultiFeatureCard from "../../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard"
import ReviewTopicPlot from "../../../../Overview/components/OverviewComp/components/ReviewTopicPlot"
import { Typography } from "@hmsexp/component-library"
import { get } from "lodash"

const TopAndBottomTopics = (props) => {

    const { applied_filter_values, itemData, timeperiodLabel } = props

    const { data, isLoading } = useFetchAiAnalyticsWidgetData({
        widgetId: "top_and_bottom_topics",
        data_tag: "DATATAG_G6_DELIGHT_OVERVIEW",
        apiResponseKey: "APITAG_G6_DELIGHT_TOP_N_BOTTOM_TOPICS",
        appliedFilterValues: applied_filter_values,
    })

    return (
        <MultiFeatureCard
            title={itemData?.title}
            subTitle={get(itemData, "subTitle", "") + " " + timeperiodLabel}
            style={{ childContainer: { minHeight: 300 } }}
            loading={isLoading}
            isNoData={false}
            enableActionBtn={true}
            enableSwitchTab={itemData?.enableSwitchTab}
            switchOptions={itemData?.switchOptions}
            renderContent={(activeSwitch, contentRef) => {
                return (
                    <ReviewTopicPlot
                        isLoading={isLoading}
                        type={activeSwitch}
                        widgetData={itemData}
                        itemData={data}
                        contentRef={contentRef}
                    />
                );
            }}
            renderFooter={() => (
                <Typography fontWeightType='regular' variant='button'>
                    {itemData?.footerText}
                </Typography>
            )}
        />)
}
export default TopAndBottomTopics